import { IEltTopIssue } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltTopIssue'
import { TComplexSectionData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { useTableActions } from 'legacy/lut/components/widgets/public/partner360/ELT/hooks/useTableActions'
import { getTopIssueColumns } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/docContent/step1/components/topIssues/getTopIssueColumns'
import { StyledTable } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/StyledTable'
import { useMemo } from 'react'

import styles from './Issues.module.scss'

interface IProps {
  data: IEltTopIssue[]
  updateFormData: (data: TComplexSectionData) => void
}

const newEmptyRow: IEltTopIssue = { Issue: '', HpProgress: '' }

export const TopIssues = ({ data, updateFormData }: IProps) => {
  const { addRow, deleteRow, deleteLastRow, onChange, canAddNewRow } =
    useTableActions<IEltTopIssue>({
      updateFormData: updateFormData,
      data: data,
      newEmptyRow,
      canAddNewRowCondFn: (el) => !el.Issue && !el.HpProgress,
    })
  const columns = useMemo(() => getTopIssueColumns({ onChange }), [onChange])
  return (
    <div className={styles.root}>
      <StyledTable<IEltTopIssue>
        title={getFormedEltTranslation('doc-section-top-issues')}
        canAddNewRow={canAddNewRow}
        columns={columns}
        items={data}
        addRow={addRow}
        deleteLastRow={deleteLastRow}
        deleteRow={deleteRow}
        maxLen={5}
      />
    </div>
  )
}
